export * from '@primeuix/themes/lara/base';
export { default } from '@primeuix/themes/lara/base';
